import { FreeSpinsRainbowOverlayProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/FreeSpinsRainbowOverlayProperties";
export class FreeSpinsRainbowOverlayPortraitProperties extends FreeSpinsRainbowOverlayProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.overlayProperties.position.set(512, 973);
    }
}
